<template>
  <div class="page-wrapper" style="padding-top: 0">
    <Modal v-model="isShow" :mask-closable="false"
           :width="620"
    >
      <h4 class="mb8">退款渠道明细</h4>
      <Table :columns="paymentColumn" :data="paymentBillList" class="mb32"></Table>
    </Modal>
  </div>
</template>

<script>
  import {refund } from "../../../../../../api/book";


  export default {
    name: "BillInfo",
    props: {
      n: {
        type: Number,
        default: 0
      },
      paymentFid:{
        type: String,
        default: ''
      }
    },
    watch: {
      n() {
        this.isShow=true
        this.getPaymentList()
      }
    },
    data() {
      return {
        isShow:false,
        paymentBillList: [],
        paymentColumn: [
          {
            title: "渠道",
            key: "paymentCanalName",
            align: "center"

          },
          {
            title: "退款金额",
            key: "payAmount",
            align: "center",
            render: (h, params) => {
              return h('span', {}, (Math.abs(params.row['payAmount']) / 100).toFixed(2))
            }
          },
          {
            title: "退款流水",
            key: "billDetailNum",
            align: "center"

          },
          {
            title: "收款单号",
            key: "receiptNum",
            align: "center"

          },
          {
            title: "退款状态",
            key: "payStatus",
            align: "center",
            render: (h, params) => {
              let maps = {'1': '退款中', '2': '退款完成', '3': '退款失败'}
              return h('span', {}, maps[params.row['payStatus'] + ''])
            }
          },
          {
            title: "备注",
            key: "lowerType",
            align: "center",
            render: (h, params) => {
              return h('span', {}, params.row['payStatus'] === 1?'已退账户空间':'')
            }
          }
        ]
      }
    },
    methods: {

      getPaymentList(){
        if(!this.paymentFid){
          return
        }
        let param = {paymentFid: this.paymentFid}
        refund(param).then(res => {
          this.paymentBillList = res.data;
        }).catch(error => {

        })
      }

    }
  }
</script>

<style scoped>

</style>
